declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../../services/spinner.service';
import { AppData } from '../../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../services/hcp.service';


import * as alertFunctions from '../../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest } from '../../../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../../../models/actor/actor';
import { ActorService } from '../../../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../../../models/master/mastermodel';
import { FDService } from '../../../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';

@Component({
  selector: 'fseditview',
    templateUrl: './fseditview.modal.html',
    styleUrls: ['./fseditview.modal.scss']
})

export class NgbFsEditViewModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
  @Input() ActorCode;
  @Input() IsShowDetail: boolean = false;
  //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
  @Input() ServiceCode: number;
  searchTitle: string;
  public ApiResData: ApiResponseModel;

  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  //public IsSelected: boolean;
    ExtractionDate: NgbDateStruct;
  CurrentActorAddEmergencyInfoRequest: SaveEmergencyContactInfoRequest;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
    private tosterservice: NGXToastrService) { }
  ngOnInit() {
    this.CurrentActorAddEmergencyInfoRequest = new SaveEmergencyContactInfoRequest();
    this.CurrentActorAddEmergencyInfoRequest.ConditionalOperator = 10;
    this.CurrentActorAddEmergencyInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorAddEmergencyInfoRequest.EmergencyContactCode = 0;
    this.CurrentActorAddEmergencyInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ShowService = false;


    this.LoadRegistries();


  }




  LoadRegistries() {
    this.StartRefreshing();



    //this.GetBranchMap();


  }



  onSubmit() {

    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
    this.CurrentActorAddEmergencyInfoRequest.AddressLine1 = "";
    this.CurrentActorAddEmergencyInfoRequest.AddressLine2 = "";
    this.hcpservice.SaveEmergencyContactInfo(this.CurrentActorAddEmergencyInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }





}
